import PrebuiltCardTypes from 'modules/prebuilt-bets/types/index.js';

const {
    PREBUILT_ACCA,
    PREBUILT_BET_BUILDER,
    PREBUILT_BET_BUILDER_BOOSTED,
    PREBUILT_BET_BUILDER_FIXED,
} = PrebuiltCardTypes.MARKETS;

/** Feed market types shown in the prebuilt bet builder carousel (combos). */
const PREBUILT_BET_BUILDER_MARKET_TYPES = new Set([
    PREBUILT_BET_BUILDER,
    PREBUILT_BET_BUILDER_BOOSTED,
    PREBUILT_BET_BUILDER_FIXED,
]);

const feedMarketMatchesFilter = (filterMarketType, feedMarketType) => {
    if (filterMarketType === PREBUILT_BET_BUILDER) {
        return PREBUILT_BET_BUILDER_MARKET_TYPES.has(feedMarketType);
    }

    if (filterMarketType === PREBUILT_ACCA) {
        return feedMarketType === PREBUILT_ACCA;
    }

    return feedMarketType === filterMarketType;
};

/**
 * Whether a prebuilt_cards promotion belongs to the requested carousel filter.
 * Bet builder carousels use {@link Mojito.Modules.PrebuiltBets.types.MARKETS.PREBUILT_BET_BUILDER}
 * and include PBBB, PBMK, and PBMF feed markets. Acca carousels use PBAC only.
 *
 * @param {Mojito.Services.Promotions.types.Promotion} promotion - Promotion the card was created from.
 * @param {string} [marketType] - Carousel filter ({@link Mojito.Modules.PrebuiltBets.types.MARKETS} value).
 * @param {object} [market] - Market from the sports content store.
 * @returns {boolean} True if the promotion belongs to the carousel, or if no filter is given.
 */
export const promotionMatchesPrebuiltMarketType = (promotion, marketType, market) => {
    if (!marketType) {
        return true;
    }

    if (market?.type) {
        return feedMarketMatchesFilter(marketType, market.type);
    }

    const cmsMarket = promotion.event?.market;
    if (!cmsMarket) {
        return false;
    }

    if (marketType === PREBUILT_BET_BUILDER) {
        return cmsMarket.isPreBuiltBetBuilder === true;
    }

    if (marketType === PREBUILT_ACCA) {
        return cmsMarket.isPreBuiltBetBuilder !== true;
    }

    return false;
};
